export default {
 'today.subscribe': 1,
 'kline.unsubscribe': 2,
 'kline.subscribe': 3,
 'kline.query': 4,
 'today.unsubscribe': 5,
 'deals.query': 6
}